// extracted by mini-css-extract-plugin
export default {"container":"RequestResetPasswordPage_container__eWLGl","width":"RequestResetPasswordPage_width__LTash"};